<template>
  <div class="tc-container">
    <div class="tc-chart">
      <div ref="myChart" class="myChart"></div>
      <div
        class="circular"
        :style="{ border: '2px dashed ' + item.dashed }"
        ref="circular"
      ></div>
    </div>
    <div class="tc-title">
      {{ item.name }}
      <span ref="number">{{ item.number }}</span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    beforeDestroy() {
      this.$animejs.remove([this.$refs.circular, this.$refs.number])
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          title: {
            text: ((this.item.number / this.item.total) * 100).toFixed(0) + '%',
            subtext: '',
            x: 'center',
            y: 'center',
            textStyle: {
              color: '#fff',
              fontSize: 18,
              fontWeight: 'normal',
            },
          },
          legend: {
            x: 'center',
            y: 'bottom',
            data: ['rose3', 'rose5', 'rose6', 'rose7', 'rose8'],
          },
          series: [
            {
              name: '面积模式',
              type: 'pie',
              radius: [39, 43],
              center: ['50%', '50%'],
              labelLine: {
                show: false,
              },
              data: [
                {
                  value: this.item.number,
                  itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      1,
                      0,
                      0,
                      [
                        {
                          offset: 0,
                          color: this.item.color[0],
                        },
                        {
                          offset: 1,
                          color: this.item.color[1],
                        },
                      ]
                    ),
                  },
                },
                {
                  value: this.item.total,
                  name: 'rose2',
                  itemStyle: {
                    color: 'transparent',
                  },
                },
              ],
            },
            {
              name: '面积模式',
              type: 'pie',
              radius: [40, 43],
              center: ['50%', '50%'],
              labelLine: {
                show: false,
              },
              data: [
                {
                  value: this.item.number,
                  itemStyle: {
                    color: 'transparent',
                  },
                },
                {
                  value: this.item.total,
                  name: 'rose2',
                  itemStyle: {
                    color: '#272A2C',
                  },
                },
              ],
            },
          ],
        })
        myChart.setOption(option)
        this.$animejs({
          targets: this.$refs.circular,
          easing: 'linear',
          loop: true,
          rotate: 360,
          duration: 6000,
        })
        // 数字滚动动画
        this.$animejs({
          targets: this.$refs.number,
          innerHTML: [0, this.item.number],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    width: 100%;
    .tc-chart {
      width: 5vw;
      height: 5vw;
      margin: 0 auto;
      position: relative;
      .myChart {
        width: 5vw;
        height: 5vw;
      }
      .circular {
        position: absolute;
        left: 15px;
        top: 15px;
        bottom: 15px;
        right: 15px;
        border: 2px dashed #02ffa3;
        border-radius: 50%;
      }
    }
    .tc-title {
      color: #e6e6e6;
      text-align: center;
      font-size: 12px;
      span {
        font-size: 1.1458vw;
        color: white;
      }
    }
  }
</style>
